const SEEK_TOLERANCE = 0.75
const CORRECTION_TIMEOUT = 6000
// 纠正指令下发后若未落地（用户拖拽产生的原生 seek 会覆盖 programmatic seek），
// 需要按该间隔重复下发，否则未完成课程会被拖到未观看位置并持续播放。
const CORRECTION_RETRY_MS = 400

export function createPlaybackGuard (position = 0, now = 0) {
  const safePosition = typeof position === 'number' && isFinite(position) ? Math.max(0, position) : 0
  return {
    position: safePosition,
    maxWatched: safePosition,
    updatedAt: now,
    seeking: false,
    paused: false,
    correctionTarget: null,
    correctionStartedAt: 0,
    correctionIssuedAt: 0,
    // 该轮纠正发生在「页面从后台恢复 / 页面不可见」等不可信上下文时只纠正一次，
    // 不重复拉回，避免把系统冻结后的真实播放误判成用户拖拽。
    correctionSoft: false,
    blocked: false
  }
}

export function inspectPlaybackProgress (state, time, now, options = {}) {
  if (typeof time !== 'number' || !isFinite(time) || time < 0) return { accepted: false }
  if (state.blocked && !options.unrestricted) return { accepted: false, blocked: true }

  const seeking = !!options.seeking
  if (options.unrestricted) {
    state.correctionTarget = null
    state.correctionSoft = false
    state.blocked = false
  } else if (state.correctionTarget !== null) {
    if (Math.abs(time - state.correctionTarget) <= SEEK_TOLERANCE && !seeking) {
      state.position = time
      state.updatedAt = now
      state.seeking = false
      state.correctionTarget = null
      state.correctionSoft = false
      return { accepted: true, corrected: true }
    }
    if (now - state.correctionStartedAt >= CORRECTION_TIMEOUT) {
      state.blocked = true
      return { accepted: false, blocked: true }
    }
    // 纠正指令未落地：节流式重复下发，抵消被 in-flight 原生 seek 覆盖的情况。
    // soft 轮次（后台恢复等）保持只纠正一次，等超时后走既有兜底，不放大误判。
    if (!state.correctionSoft && now - state.correctionIssuedAt >= CORRECTION_RETRY_MS) {
      state.correctionIssuedAt = now
      return { accepted: false, correctionTarget: state.correctionTarget, retry: true }
    }
    return { accepted: false }
  }

  const elapsed = state.updatedAt ? Math.max(0, (now - state.updatedAt) / 1000) : 0
  const rate = typeof options.playbackRate === 'number' && isFinite(options.playbackRate)
    ? Math.max(0.25, Math.min(options.playbackRate, 4))
    : 1
  const wasSeeking = seeking || state.seeking
  const remainedPaused = !!options.paused && state.paused
  const allowance = Math.max(3, elapsed * rate + 2)
  const boundary = wasSeeking || remainedPaused ? state.maxWatched : Math.max(state.maxWatched, state.position + allowance)

  if (!options.unrestricted && time > boundary + (wasSeeking ? 0.05 : 0)) {
    state.correctionTarget = Math.max(0, state.position)
    state.correctionStartedAt = now
    state.correctionIssuedAt = now
    state.correctionSoft = !!options.soft
    state.seeking = true
    return { accepted: false, correctionTarget: state.correctionTarget }
  }

  state.seeking = seeking
  if (seeking) return { accepted: false }
  state.position = time
  if (!wasSeeking && !remainedPaused) state.maxWatched = Math.max(state.maxWatched, time)
  state.paused = !!options.paused
  state.updatedAt = now
  return { accepted: true }
}



// WEBPACK FOOTER //
// ./src/utils/playbackGuard.js